<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      d="m9.1 12.8-2.7 2.6h14.9v2.3H6.4l2.7 2.7L7.5 22 2 16.6l5.5-5.4zM22 7.4l-5.5 5.4-1.6-1.6 2.7-2.6H2.7V6.3h14.9l-2.7-2.7L16.5 2z"
    />
  </svg>
</template>
